export enum PermissionForms {
    UserSectionForm = 1, // فرم دپارتمان
    AuthUserForm = 2, // فرم کاربران
    UserGeneralDetailsForm = 3, // جزییات عمومی کاربران
    UserDetailsForm = 4, // جزییات تخصصی کاربران
    FlowForm = 5, //لیست نوع درخواست ها
    FlowSettingForm = 6, // تنظیمات نوع درخواست 
    FlowFormBuilderForm = 7, // تنظیمات  اطلاعات تکمیلی نوع درخواست
    RequestsForm = 8, // لیست درخواست ها
    RequestDetailForm = 9, // جزییات درخواست
    RequestFormBuilderForm = 10, // اطلاعات تکمیلی درخواست
    NotificationsForm = 11, // اعلانات
    SmsForm = 12, //پیامک ها
    SystemSettingForm = 13, // مدیریت تنظیمات عمومی
    SystemIntroductionForm = 14, // مدیریت نحوه معرفی
    FormAccessForm = 15,     //مدیریت دسترسی به فرمها
    DynamicFieldForm = 5, //لیست نوع درخواست ها
    AccountProduct = 5, //لیست نوع درخواست ها
    AccountForm = 5, //لیست نوع درخواست ها
    AccountEventForm = 5, //لیست نوع درخواست ها
    ContactForm = 5, //لیست نوع درخواست ها
    AccountContactsForm = 5, //لیست نوع درخواست ها
    AccountMenuForm = 5, //لیست نوع درخواست ها
    OrderForm = 5, //لیست نوع درخواست ها
    InventoryManageForm = 5, //لیست نوع درخواست ها
}


export class PermissionRoleModel {
    id: number;
    title: string;

    constructor(id: number, title: string) {
        this.id = id;
        this.title = title;
    }

    public static fromJson(json: any): PermissionRoleModel {
        return new PermissionRoleModel(
            json["id"],
            json["title"],
        );
    }
}


export class PermissionUserModel {
    id: number;
    userName: string;

    constructor(
        id: number,
        userName: string,
    ) {
        this.id = id;
        this.userName = userName;
    }

    public static fromJson(json: any): PermissionUserModel {
        return new PermissionUserModel(
            json["id"],
            json["userName"],
        );
    }
}


export class PermissionModel {
    id: number;
    roleId: number;
    formId: number;
    formTitle: string;
    show: boolean;
    insert: boolean;
    update: boolean;
    deleted: boolean;
    [key: string]: any;

    constructor(
        id: number,
        roleId: number,
        formId: number,
        formTitle: string,
        show: boolean,
        insert: boolean,
        update: boolean,
        deleted: boolean,
    ) {
        this.id = id;
        this.roleId = roleId;
        this.formId = formId;
        this.formTitle = formTitle;
        this.show = show;
        this.insert = insert;
        this.update = update;
        this.deleted = deleted;
    }

    public static fromJson(json: any): PermissionModel {
        return new PermissionModel(
            json["id"],
            json["roleId"],
            json["formId"],
            json["formTitle"],
            json["show"],
            json["insert"],
            json["update"],
            json["delete"],
        );
    }
}

export class PermissionPayloadModel {
    RoleId: number;
    FormId: number;
    Show: boolean;
    Insert: boolean;
    Update: boolean;
    Delete: boolean;

    constructor(
        RoleId: number,
        FormId: number,
        Show: boolean,
        Insert: boolean,
        Update: boolean,
        Delete: boolean,
    ) {
        this.RoleId = RoleId;
        this.FormId = FormId;
        this.Show = Show;
        this.Insert = Insert;
        this.Update = Update;
        this.Delete = Delete;
    }
}




//#region New
export class FormModel {
    id: number;
    SysName: string;
    title: string;
    hasAccess: boolean;

    constructor(
        id: number,
        SysName: string,
        title: string,
        hasAccess: boolean
    ) {
        this.id = id;
        this.SysName = SysName;
        this.title = title;
        this.hasAccess = hasAccess
    }

    public static fromJson(json: any): FormModel {
        return new FormModel(
            json["id"],
            json["SysName"],
            json["title"],
            json["hasAccess"]
        );
    }
}
export interface PermissionGetPayloadFilterModel {
    id?: number;
    RoleId?: number;
    FormId?: number;
    isActive?: number;
}

export interface PermissionGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: PermissionGetPayloadFilterModel;
}


export default PermissionModel;



//#endregion